/*
Sohel 03/20/2023 2699762545 removed Field Position
Akhila 03/20/2023 2699762545 disable the save button and handleNext implemented
Sohel 03/22/2023 2698964415 Letter Field Payload Changes
Sohel 03/27/2023 2699762545 Payload Changes
Dilip 03/27/2023 2699762545 added bredcrums to show code and description
Akhila 03/27/2023 2699762545 Added save button
Prakash 03/27/2023 2699762545 Added class name for table.
Guru Prasad 04/11/2023 2699762545 Fixed alignments
Ravi 04/12/2023 2699762545 Added unsaved popup changes
Akhila 05/24/2024 2699762545 role access implemeneted
Akhila 05/30/2023 2699762545 unsaved changes bug fixed
Ravi 06/20/2023 2699762545 Added Breadcrum in popup
Ravi 06/21/2023 2699762545 fixed submit issue
*/
import {Field, FieldArray, Form, Formik} from 'formik';
import React, {useEffect, useRef, useState} from 'react';
import DialogBox from '../../../components/DialogBox';
import {Button} from '@material-ui/core';
import AccountTreeIcon from '@material-ui/icons/AccountTree';
import SearchFields from '../../FrameWorks/GlobalFields/DataRepositories/SearchDataRepositories/index';
import {useDispatch, useSelector} from 'react-redux';
import {
  fetchLetterFormatFields,
  postLetterFormatFields,
  resetLetterFormatFields,
} from '../../../redux/reducers/LetterMaintainance/NewLetterMaintenance';
import LetterFormatFields from './LetterFormatFieldsComponents/LetterFormatFields';
import PageLoader from '../../../components/PageLoader';
import {ErrorSnackbar, SuccessSnackbar} from '../../../components/CustomSnackBar';
import BreadCrums from '../../../util/BreadCrum';
import {submissionStart} from '../../../redux/reducers/CommonActions/commonActions';
import reusableInputStyles from '../../../components/InputStyles';

function LetterFields({
  handleBack,
  handleNext,
  hidden,
  handleDirty,
  LetterMainAccess,
  editExisting,
}) {
  const classes = reusableInputStyles();
  const [open, setOpen] = useState(false);
  const [tempSelectedRows, setTempSelectedRows] = useState([]);
  const [deletedIds, setDeletedIds] = useState([]);
  const dmArrayHelpers = useRef();
  const saveRef = useRef();
  const dispatch = useDispatch();
  const {
    letterCode,
    isLetterFieldsLoading,
    letterFieldsSuccessMsg,
    letterFieldsErrorMsg,
    letterFieldsStatus,
    letterFieldsData,
    basicInfoData,
  } = useSelector(({newLetterMaintenance}) => newLetterMaintenance);
  const {enabledSubmission} = useSelector(({commonActions}) => commonActions);
  const initialVal = {
    selectedFields: [],
  };
  useEffect(() => {
    handleDirty(false, 'reset');
  }, []);
  const [initialValues, setInitialValues] = useState(initialVal);
  const handleClose = () => {
    setOpen(false);
  };
  useEffect(() => {
    if (letterFieldsData?.length > 0) {
      const fieldsData = letterFieldsData?.map((el) => {
        return {
          ...el,
          repositoryName: el?.dataRepoField,
          fieldName: el?.letterField,
          letterFieldName: el?.templateFieldName,
        };
      });
      setInitialValues({...initialValues, selectedFields: fieldsData});
    }
  }, [letterFieldsData]);
  useEffect(() => {
    if (letterFieldsErrorMsg || letterFieldsSuccessMsg) {
      setTimeout(() => {
        if (letterFieldsStatus === 200 && !saveRef.current && letterFieldsSuccessMsg) {
          handleNext();
        } else if (letterFieldsStatus === 200 && saveRef.current && letterFieldsSuccessMsg) {
          dispatch(fetchLetterFormatFields(letterCode));
        }
        dispatch(resetLetterFormatFields());
      }, 2000);
    }
  }, [letterFieldsErrorMsg, letterFieldsSuccessMsg]);
  const columns = [
    {
      title: 'Actions',
    },
    {
      title: 'Repository Name',
    },
    {
      title: 'Field Name',
    },
    {
      title: 'Letter Field Name',
    },
  ];
  const onSubmit = (values) => {
    if (values?.selectedFields?.length > 0) {
      dispatch(submissionStart());
      const letterFields = values?.selectedFields?.map((el) => {
        return {
          dataRepoField: el?.repositoryName,
          functionValue: '',
          letterField: el?.fieldName,
          letterFieldId: el?.letterFieldId ? el?.letterFieldId : 0,
          templateFieldName: el?.letterFieldName,
        };
      });
      const payload = {
        letterSortFieldDeleteIds: deletedIds?.length > 0 ? [...new Set(deletedIds)] : [0],
        letterFieldRequestList: letterFields,
        letterCode: letterCode,
        isDraft: basicInfoData?.isDraft === 'N' ? 'N' : 'Y',
        lastStep: hidden ?
          basicInfoData?.lastStep > 5 ?
            basicInfoData?.lastStep :
            5 :
          basicInfoData?.lastStep > 6 ?
            basicInfoData?.lastStep :
            6,
      };
      dispatch(postLetterFormatFields(payload));
    }
  };
  useEffect(() => {
    if (letterCode) {
      dispatch(fetchLetterFormatFields(letterCode));
    }
  }, [letterCode]);
  return (
    <>
      <Formik
        initialValues={initialValues}
        onSubmit={(values) => onSubmit(values)}
        validateOnChange
        enableReinitialize
      >
        {(props) => {
          const {values, setFieldValue, dirty} = props;
          handleDirty && handleDirty(dirty);
          return (
            <>
              <Form noValidate>
                <FieldArray
                  name="selectedFields"
                  render={(arrayHelpers) => {
                    dmArrayHelpers.current = arrayHelpers;
                    return (
                      <>
                        <div className="table-header justify-content-between new-standard-textfields">
                          <div>
                            <BreadCrums
                              name={'Letter Code'}
                              code={basicInfoData?.letterCode}
                              description={'Letter Description'}
                              descriptionValue={basicInfoData?.letterDescription}
                            />
                          </div>
                          <Button
                            variant="outlined"
                            className={`search-btn mx-1 ${classes.buttonRoot}`}
                            disabled={editExisting && !LetterMainAccess?.edit}
                            onClick={() => {
                              setOpen(true);
                            }}
                            startIcon={<AccountTreeIcon />}
                          >
                            Map Fields
                          </Button>
                        </div>
                        <div
                          className={
                            'mui-custom-table-container custom-table  pt-0 global-field-table text-center-table new-standard-textfields'
                          }
                        >
                          <table>
                            <thead className="recFormat-header-container">
                              <tr>
                                {columns.map(
                                  ({title, hidden = false}) =>
                                    !hidden && (
                                      <th key={title} className="recFormat-header">
                                        {title}
                                      </th>
                                    ),
                                )}
                              </tr>
                            </thead>
                            {values.selectedFields?.length > 0 ? (
                              <tbody className="recFormat-body">
                                {values.selectedFields.map((field, index) => (
                                  <>
                                    <Field
                                      key={field.fieldName + field.repositoryName}
                                      name={`selectedFields[${index}]`}
                                      component={LetterFormatFields}
                                      index={index}
                                      columns={columns}
                                      dmArrayHelpers={dmArrayHelpers}
                                      deletedIds={deletedIds}
                                      setDeletedIds={setDeletedIds}
                                      LetterMainAccess={LetterMainAccess}
                                      editExisting={editExisting}
                                    />
                                  </>
                                ))}
                              </tbody>
                            ) : (
                              <tbody>
                                <tr>
                                  <td colSpan={columns.length}>{'No records to display'}</td>
                                </tr>
                              </tbody>
                            )}
                          </table>
                        </div>
                        <DialogBox
                          open={open}
                          dialogClose={handleClose}
                          // title="Search Repository Fields"
                          title={
                            <div className="dialog-breadcrum">
                              <p className="dialoge-title-breadcrum">
                                <b>Search Repository Fields</b>
                              </p>
                              <BreadCrums
                                name={'Letter Code'}
                                code={basicInfoData?.letterCode}
                                description={'Letter Description'}
                                descriptionValue={basicInfoData?.letterDescription}
                              />
                            </div>
                          }
                          maxWidth="xl"
                        >
                          <div>
                            <SearchFields
                              isLetterMaintenance={true}
                              isReports={true}
                              mapFields={true}
                              tempSelectedRows={tempSelectedRows}
                              handleClose={handleClose}
                              setTempSelectedRows={setTempSelectedRows}
                              setDMFieldValue={setFieldValue}
                              dmValues={values}
                              dmArrayHelpers={dmArrayHelpers}
                              deletedIds={deletedIds}
                              setDeletedIds={setDeletedIds}
                            />
                          </div>
                        </DialogBox>
                      </>
                    );
                  }}
                />

                <div className="d-flex justify-content-center  mt-3 new-standard-textfields">
                  <Button
                    onClick={() => {
                      handleBack();
                    }}
                    variant="outlined"
                    className={`mx-1 reset-btn ${classes.buttonRoot}`}
                  >
                    Back
                  </Button>
                  {/* {basicInfoData?.isDraft === "N" && ( */}
                  <Button
                    variant="outlined"
                    className={`search-btn ml-1 mr-1 ${classes.buttonRoot}`}
                    disabled={(editExisting && !LetterMainAccess?.edit) || enabledSubmission}
                    type="submit"
                    onClick={() => {
                      // onSubmit();
                      saveRef.current = true;
                      handleDirty(false, 'fixed');
                    }}
                  >
                    Save
                  </Button>
                  {/* )} */}
                  <Button
                    variant="outlined"
                    type="submit"
                    className={`search-btn ml-1 mr-1 ${classes.buttonRoot}`}
                    disabled={(editExisting && !LetterMainAccess?.edit) || enabledSubmission}
                    onClick={() => {
                      saveRef.current = false;
                      // onSubmit();
                    }}
                  >
                    Save & Next
                  </Button>
                </div>
              </Form>
            </>
          );
        }}
      </Formik>
      {isLetterFieldsLoading && <PageLoader />}
      {letterFieldsErrorMsg && <ErrorSnackbar errorMsg={letterFieldsErrorMsg} />}
      {letterFieldsSuccessMsg && <SuccessSnackbar successMsg={letterFieldsSuccessMsg} />}
    </>
  );
}
export default LetterFields;
